import { z } from "zod";

export const schema = z.object({
	id_taxa_entrega: z.number().int(),
	valor: z
		.union([z.string(), z.number()])
		.transform((value) => {
			if (typeof value === "string") {
				const parsed = parseFloat(value.replace(",", "."));
				return isNaN(parsed) ? 0 : parsed;
			}
			return value;
		})
		.refine((value) => value > 0, {
			message: "Valor deve ser maior que 0",
		}),
	distancia: z
		.union([z.string(), z.number()])
		.transform((value) => {
			if (typeof value === "string") {
				const parsed = parseInt(value, 10);
				return isNaN(parsed) ? 0 : parsed;
			}
			return Math.round(value);
		})
		.refine((value) => value > 0, {
			message: "Distância deve ser maior que 0",
		}),

	ativo: z.boolean(),
});

export const defaultValues = {
	id_taxa_entrega: 0,
	valor: "",
	distancia: "",
	ativo: true,
};
